"use client"

import Image from "next/image"
import Link from "next/link"
import { useLanguage } from "@/lib/i18n/language-provider"

export function LandingFooter() {
  const { t } = useLanguage()

  const links = [
    { label: t("footer.about"), href: "/about" },
    { label: t("footer.changelogs"), href: "/changelogs" },
    { label: t("footer.downloads"), href: "/downloads" },
    { label: t("footer.privacy"), href: "/privacy" },
    { label: t("footer.terms"), href: "/terms" },
  ]

  return (
    <footer className="border-t border-border py-12 md:py-16">
      <div className="container px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo and title */}
          <div className="flex items-center gap-3">
            <div className="relative w-10 h-10">
              <Image src="/icon.png" alt="VisualGrid" fill className="object-contain" />
            </div>
            <div className="text-xl font-bold">VisualGrid</div>
          </div>

          {/* Subtitle */}
          <div className="text-sm text-muted-foreground text-center md:text-left">LED Test Pattern Generator Pro</div>

          {/* Links */}
          <nav className="flex items-center gap-6">
            {links.map((link, index) => (
              <Link
                key={index}
                href={link.href}
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  )
}

